import AbstractObservable from './AbstractObservable'

interface ISnapState {
  resolution: number
  snap: boolean
}

class SnapManager extends AbstractObservable<ISnapState> {
  constructor(initial = { resolution: 1, snap: true }) {
    super(initial)
  }

  private onKeyDown = (evt: KeyboardEvent) => {
    if (evt.key === 'Meta' || evt.key === 'Control') {
      const state = this.state
      this.update({ ...state, snap: !state.snap })
    }
  }
  private onKeyUp = (evt: KeyboardEvent) => {
    if (evt.key === 'Meta' || evt.key === 'Control') {
      const state = this.state
      this.update({ ...state, snap: !state.snap })
    }
  }

  initHotKeys() {
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
  }

  removeHotKeys() {
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyDown)
  }
}

export default new SnapManager()
